<template>
  <div>
    <Loading :visible="isLoadingPop"></Loading>
    <div class="wrap login-wrap">
      <div class="logo-wrap">
        <img src="@/assets/img/logo_coach.png" class="w-270px" alt="better and better" />
        <p>로그인</p>
      </div>
      <div class="login-form">
        <!-- 로그인 실패 문구 -->
        <div class="fail mb-40" v-if="isFail">
          <p class="txt-red">로그인 {{ failCount }}회 실패하였습니다.</p>
          <p>비밀번호를 재설정 해주시기 바랍니다.</p>
        </div>
        <ul>
          <!-- <li>
                        <input type="text" placeholder="기업코드를 입력하세요.">
                    </li> -->
          <li>
            <input type="text" placeholder="아이디(이메일)을 입력해 주세요." v-model="input.userId" />
            <!-- 인증된 메일일 경우 노출 -->
            <!-- <img src="img/login-check-ok.svg" alt="checked" class="check-img"> -->
            <!-- 인증되지 않은 메일일 경우 -->
            <!-- <img src="img/login-check-error.svg" alt="checked" class="check-img"> -->
          </li>
          <!-- 인증된 메일일 경우 노출 -->
          <!-- <p>인증된 메일입니다.</p> -->

          <!-- 인증된 메일일 경우 비밀번호 입력란 노출 -->
          <li>
            <input type="password" placeholder="비밀번호를 입력해 주세요" v-model="input.password" />
          </li>
          <!-- 비밀번호가 틀렸을 경우 -->
          <p class="txt-red" v-if="isErrChk">비밀번호를 혹은 아이디를 확인해 주세요.</p>
        </ul>
        <div class="remember-id">
          <label><input type="checkbox" value="false" v-model="isAuto" /> <span>자동 로그인</span></label>
        </div>
      </div>

      <div class="bnb-btn">
        <!-- 기업코드 혹은 아이디 입력 시 class="active" 활성화 -->
        <!-- <button>계속하기</button> -->

        <!-- 기업코드와 아이디가 인증이 된 항목일 경우 로그인 버튼으로 바뀜 -->
        <button class="active" @click="login()">로그인</button>
        <p @click="passowrdAccount()">비밀번호를 잊으셨나요?</p>
        <p v-if="isFail" @click="passowrdAccount()">비밀번호 재설정 하러 가기</p>
      </div>
    </div>
  </div>
</template>
<script>
import { fcmSetting, receivedNotifcation } from "@/module/noti.js";
import { EmptyCheck } from "@/utils/validation";
import LogRocket from "logrocket";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "login",
  data: () => ({
    input: {
      userId: "",
      password: "",
      deviceId: "",
    },
    isErrChk: false,
    isAuto: false,
    isFail: false,
    failCount: 0,
    isLoadingPop: false,
  }),
  components: {
    Loading,
  },
  mounted() {
    LogRocket.init("bnb-platform-coach/bnb-platform-coach");
    fcmSetting();
    // console.log(localStorage.getItem("isAuto"));
    if (localStorage.getItem("isAuto") != null && localStorage.getItem("isAuto") != 0) {
      this.isAuto = true;
      this.$router.push("my_coaching");
      receivedNotifcation();
    } else {
      localStorage.clear();
    }
  },
  methods: {
    login() {
      this.input.deviceId = localStorage.getItem("fcmtoken");
      if (!EmptyCheck(this.input.userId, "아이디를")) {
        this.isErrChk = true;
        return false;
      }
      if (!EmptyCheck(this.input.password, "비밀번호를")) {
        this.isErrChk = true;
        return false;
      }

      let params = this.input;
      this.isErrChk = false;
      this.isLoadingPop = true;
      this.axios
        .post("/auth/coarch-login", params)
        .then((res) => {
          if (res.data.success) {
            LogRocket.identify(this.input.userId, {
              name: this.input.userId,
              email: this.input.userId,
              subscriptionType: "pro",
            });
            localStorage.setItem("accessToken", res.data.contentinfo.access_token);
            // // localStorage.setItem("UserIdx",res.data.contentinfo.UserIdx);
            // // localStorage.setItem("UserName",res.data.contentinfo.UserName);
            // // localStorage.setItem("UserLevel",res.data.contentinfo.UserLevel);
            // // localStorage.setItem("userEmail",res.data.contentinfo.userEmail);
            localStorage.setItem("idxTbCoarch", res.data.contentinfo.coachInfo.coarIdx);

            let userInfo = {
              userIdx: res.data.contentinfo.userInfo.userIdx,
              userName: res.data.contentinfo.userInfo.username,
              userLevel: res.data.contentinfo.userInfo.userLevel,
              userEmail: res.data.contentinfo.userInfo.userId,
              idxTbCoarch: res.data.contentinfo.coachInfo.coarIdx,
              userHandphone: res.data.contentinfo.userInfo.userHandphone,
            };
            this.$store.commit("setUserInfo", userInfo);
            if (this.isAuto) {
              console.log("isAuto");
              localStorage.setItem("isAuto", "1");
              localStorage.setItem("userId", this.input.userId);
              localStorage.setItem("password", this.input.password);
            } else {
              localStorage.setItem("isAuto", "0");
              localStorage.setItem("userId", "");
              localStorage.setItem("password", "");
            }
            this.isLoadingPop = false;
            this.$router.push("my_coaching");
            receivedNotifcation();
          } else {
            this.isLoadingPop = false;
            this.failCount = res.data.userPasswordFailureCount;
            if (this.failCount >= 5) {
              alert("비밀번호 연속 5회 실패하였습니다.");
              // this.$router.push({
              //   name: "password_account",
              //   params: { isAccount: 1 },
              // });
            }
            this.isFail = true;
            this.isErrChk = true;
          }
        })
        .catch((err) => {
          this.isLoadingPop = false;
          this.isErrChk = true;
          console.log(err);
        });

      // return false;
      // this.axios.post("/auth/coarch-login",params).then((res)=>{
      //     console.log(res);
      // }).catch((err)=>{
      //     console.log(err)
      // })
    },
    passowrdAccount() {
      this.$router.push({ name: "password_account", params: { isAccount: 0 } });
    },
  },
};
</script>
